import React, {Component, Fragment} from 'react';
import styled from 'styled-components';
import isEqual from 'react-fast-compare';
import ErrorsViewForm from './components/ErrorsViewForm';
import AgentsViewForm from './components/AgentsViewForm';
import CarInfoViewForm from './components/CarInfoViewForm';
import SystemViewForm from './components/SystemViewForm';
import {connect} from 'react-redux';
import CarErrorsActions from '../../redux/CarErrorsRedux';
import CarsActions from '../../redux/CarsRedux';
import CarAddForm from './components/CarAddForm';
import CarTOForm from './components/CarTOForm';
import BillingView from './components/BillingView';
import DictionariesActions from '../../redux/DictionariesRedux';

const CarViewFormContainer = styled.div`
  padding-left: 8px;
  padding-right: 8px;
`;

class CarPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      car: {
        agents: [],
        system: {},
      },
    };
  }
  componentDidMount() {
    if (this.props.data.id && this.props.car) {
      this.setState({
        car: this.props.car,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data.id !== this.props.data.id && this.props.car) {
      this.setState({
        car: this.props.car,
      });
    }
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching) {
        if (!this.props.error) {
          if (this.props.car && this.props.car.id && !isEqual(this.state.car, this.props.car)) {
            this.setState({
              car: this.props.car,
            });
          }
        }
    }
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {update} = this.props;
    const {car} = this.state;
    let dataForUpdate = {};
    Object.keys(car).map(key => {
      if (!isEqual(car[key], this.props.car[key])) {
        dataForUpdate[key] = car[key];
      }
    })
    if (Object.keys(dataForUpdate).length === 0) {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.

    } else {
      update({
        ...dataForUpdate,
        id: this.props.car.id
      });
    }
  }

  onCancel = () => {
    this.setState({
      car: this.props.car
    });
  }

  onChangeSystemStatus = () => {
    const {update, car} = this.props;
    update({
      status: car.system.status === 'ACTIVATED' ? 'DEACTIVATED' : 'ACTIVATED',
      id: this.props.car.id
    });
  }

  onChange = (name, value) => {
    if (name.includes('.')) {
      const path = name.split('.');
      if (path.length === 2) {
        let obj = {...this.state.car[path[0]]};
        obj[path[1]] = value;
        this.setState({
          car: {...this.state.car, [path[0]]: obj},
        });
      }
    } else {
      this.setState({
        car: {...this.state.car, [name]: value},
      });
    }
  }
  
  render() {
    const {
      data={},
      elementProps,
      errors,
      errorsFetching,
      getErrors,
      cleanErrors,
      error,
      checkCar,
      addCar,
      fetching,
      client,
      permissions,
      dictionaries,
      getDictionaries,
    } = this.props;
    const {car} = this.state;

    return (
      <CarViewFormContainer {...elementProps}>
        {data.id === 'new' ? (
          permissions.add ? (
            <CarAddForm
              car={this.props.car}
              client={client}
              fetching={fetching}
              error={error}
              onAdd={addCar}
              onCheckCar={checkCar}
            />
          ) : null ) : (
          <Fragment>
            <form onSubmit={this.onFormSubmit}>
              <CarInfoViewForm
                {...car}
                permissions={permissions.info}
              />
            </form>
            
            <CarTOForm
              TOs={car.TOs}
              nextTO={car.nextTO}
              fetching={fetching}
              error={error}
              permissions={permissions.info}
              carId={this.props.car.id}
              onSave={this.props.update}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
            />

            <form onSubmit={this.onFormSubmit}>
              <SystemViewForm
                action={this.onChangeSystemStatus}
                fetching={fetching}
                permissions={permissions.system}
                {...car.system}
              />

              <BillingView
                billing={car.billing}
                fetching={fetching}
                permissions={permissions.billing}
              />

              <ErrorsViewForm
                errors={errors}
                fetching={errorsFetching}
                onGetErrors={() => getErrors(data.id)}
                onCleanErrors={() => cleanErrors(data.id)}
                archivePath={`${client.id}/${car.id}/errors`}
                permissions={permissions.errors}
              />

              <AgentsViewForm
                fetching={fetching}
                error={error}
                agents={car.agents}
                onChange={this.onChange}
                onCancel={this.onCancel}
              />
            </form>
          </Fragment>
        )}
      </CarViewFormContainer>
    )
  }
}

const mapStateToProps = (state, {data}) => {
  return {
    permissions: state.userProfile.permissions.client && state.userProfile.permissions.client.car,
    client: state.client.data,
    car: state.cars.data && data.id ? state.cars.data[data.id] : null,
    error: state.cars.error, 
    fetching: state.cars.fetching,
    errors: data && data.id && state.carErrors.current ? state.carErrors.current[data.id] : null,
    errorsFetching: state.carErrors.fetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    update: data => dispatch(CarsActions.carUpdateRequest(data)),
    getErrors: id => dispatch(CarErrorsActions.carErrorsRequest(id)),
    cleanErrors: id => dispatch(CarErrorsActions.carErrorsCleanRequest(id)),
    checkCar: (vin, epts) => dispatch(CarsActions.carCheckRequest(vin, epts)),
    addCar: (id, car) => dispatch(CarsActions.carAddRequest(id, car)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CarPage);

/*
const nextTO = {
  id: 'ТО-3',
  mileageLeft: 915,
  mileage: 1500,
  daysLeft: 112,
  days: 183,
}
const TOs = [
  {
    id: 'ТО-0',
    date: '2020-01-02',
    comment: 'Проведено ТО самостоятельно, согласно сервисному регламенту.'
  },
  {
    id: 'ТО-1',
    date: '2020-02-05',
    odometer: 25734,
    dealer: {
      id: 3,
      title: 'Луидор-Уфа'
    },
    tasks: {
      0:'П',
      1:'З',
      2:'П',
      3:'З',
      4:'З',
      5:'П',
      6:'П',
      7:'П',
      8:'П',
      9:'П',
      10:'П',
      11:'З',
      12:'П',
      17:'П',
      18:'З',
      19:'П',
      21:'П',
      22:'П',
      23:'П',
      24:'П',
      25:'П',
      26:'П',
      27:'П',
    }
  }
];
*/